import { render } from "./ShukkaPage.vue?vue&type=template&id=251797f2"
import script from "./ShukkaPage.vue?vue&type=script&lang=js"
export * from "./ShukkaPage.vue?vue&type=script&lang=js"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__